import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { JobService } from 'src/app/core/services/job.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { JobMatchAction } from 'src/app/core/models/jobMatchAction';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { OverrideCandidateSuspensionComponent } from 'src/app/shared/override-candidate-suspension/override-candidate-suspension.component';
import { UploadResumesTransactionCandidatesModalComponent } from 'src/app/pages/mission-control-page/add-candidates-page/upload-resumes/upload-resumes-transaction-candidates-modal/upload-resumes-transaction-candidates-modal.component';
import { OverrideNoteDetail } from 'src/app/public/app/models/overrideNoteDetail';

declare var libphonenumber: any;
declare var bootbox: any;
declare var angular: any;
declare var _: any;

@Component({
  selector: 'app-review-candidate-pull-from-job-boards',
  templateUrl: './review-candidate-pull-from-job-boards.component.html',
  styleUrls: ['./review-candidate-pull-from-job-boards.component.css']
})
export class ReviewCandidatePullFromJobBoardsComponent implements OnInit {

  @Input() jbiTransactionId: string;
  @Input() jobId: string;
  @Input() reviewHtmlText: string;
  @Input() candidateDtoMap: string;
  @Input() notificationId: string;
  @Output() closeCallback = new EventEmitter<void>();

  candidateCounts: any;
  candidatesList: any[] = [];
  candidatesToAssociateList: any[] = [];
  createJobMatchesObject: any = {};
  loadingCountsInfoFlag = false;
  loadingJobMatchesInfoFlag = false;
  selectedAllCandidatesFlag = false;
  associatingCandidatesFlag = false;
  displaySelectDeselectButtonFlag: boolean;
  jobBoarPulledCandidates: any;
  activityMap: any[] = [];

  constructor(
    private authService: AuthService,
    private jobMatchActionsService: JobMatchActionsService,
    private bsModalService: BsModalService,
    private jobService: JobService,
    private jobMatchService: JobMatchService,
    private angularModalService: AngularModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private notificationsService: NotificationsService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe
  ) { }

  ngOnInit() {
    // initialize uploaded candidate count to zero
    this.candidateCounts = {
      uploadedCandidateCount: 0,
      notProcessedCandidateCount: 0,
      autoMatchedCandidateCount: 0,
      unmatchedCandidateCount: 0,
      manuallyMatchedCandidateCount: 0,
      updatedCandidateCount: 0
    };
    this.candidatesList = [];
    this.candidatesToAssociateList = [];
    this.createJobMatchesObject = {};
    this.selectedAllCandidatesFlag = false;
    this.associatingCandidatesFlag = false;

    this.createJobMatchesObject = {
      companyId: this.authService.userDetails.company.companyId,
      requisitionId: this.jobId,
      candidateIds: [],
      manuallyMatchedFromUI: true,
      jbiTransactionId: this.jbiTransactionId,
      isAddCandidate: false,
      isAssociateCandidate: false,
      overrideNoteDetails: []
    };
    // this.getJobBoardPullCounts(() => {
    //     this.getJobBoardPullMatchInfo();
    // });
    // this.getAllActivityTypes();
    if (this.candidateDtoMap) {
      this.jobBoarPulledCandidates = JSON.parse(this.candidateDtoMap);
      this.candidatesList = this.jobBoarPulledCandidates.candidates;
    }
    this._setDetails();
  }

  private _setDetails() {
    this._massageCandidateDetails();
    this._getCandidateCounts();
    this.getAllActivityTypes();
    this.setCandidateCount();
  }

  private _getCandidateCounts() {
    const create = this.jobBoarPulledCandidates && this.jobBoarPulledCandidates.create;
    const update = this.jobBoarPulledCandidates && this.jobBoarPulledCandidates.update;
    this.displaySelectDeselectButtonFlag =
      (create && create.unMatchedCandidateCount !== 0) || (update && update.unMatchedCandidateCount !== 0);
  }

  private _massageCandidateDetails() {
    angular.forEach(this.candidatesList, (val, key) => {
      if (_.isNull(val.firstName)) {
        val.firstName = '-';
      }
      if (_.isNull(val.lastName)) {
        val.lastName = '-';
      }
      if (_.isNull(val.email)) {
        val.email = '-';
      }
      if (_.isNull(val.phone)) {
        val.phone = '-';
      }
      val.name = val.firstName + ' ' + val.lastName;
      if (val.mobilePhoneCountryCodePresent) {
        const phoneNumberObject = libphonenumber.parse(val.phone.toString());
        if (phoneNumberObject.phone !== undefined) {
          val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
        }
      }

      // floor the match score to the lower integer value.
      val.score = Math.floor(parseFloat(val.score));
      val.selectedFlag = false;
      if (val.score >= val.jobThresholdScore) {
        val.intelligenceScorePassFlag = true;
      }
      let createdCandidateMatchedToJob = false;
      let updatedCandidateMatchedToJob = false;
      if (this.jobBoarPulledCandidates.create) {
        createdCandidateMatchedToJob = !this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames
          .map(can => can.candidateId).includes(val.candidateId);
      }

      if (this.jobBoarPulledCandidates.update) {
        updatedCandidateMatchedToJob = !this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames
          .map(can => can.candidateId).includes(val.candidateId);
      }
      val.candidateMatchedToJob = createdCandidateMatchedToJob || updatedCandidateMatchedToJob;
      if (val.candidateMatchedToJob) {
        val.allowManualMatch = false;
      }
      if ((val.score < val.jobThresholdScore) && val.statusOfJobMatch === 'The candidate details updated for job.') {
        val.isCandidateDetailsUpdatedForJob = true;
      }
    });
  }

  setCandidateCount() {
    if (this.jobBoarPulledCandidates) {
      const create = this.jobBoarPulledCandidates.create;
      const uploadedCandidatesCount = this.jobBoarPulledCandidates.uploadedCandidatesCount;
      this.candidateCounts = {
        uploadedCandidateCount: uploadedCandidatesCount ? uploadedCandidatesCount : 0,
        notProcessedCandidateCount: create.notProcessedCandidateCount ? create.notProcessedCandidateCount : 0,
        autoMatchedCandidateCount: create.matchedCandidateCount ? create.matchedCandidateCount : 0,
        unmatchedCandidateCount: create.unMatchedCandidateCount ? create.unMatchedCandidateCount : 0,
        manuallyMatchedCandidateCount: create.manuallyMatchedCandidateCount ? create.manuallyMatchedCandidateCount : 0,
        updatedCandidateCount: create.updatedCandidateCount ? create.updatedCandidateCount : 0
      };
    }
  }

  // getJobBoardPullCounts(successCallback) {
  //     this.loadingCountsInfoFlag = true;
  //     this.jobService.getJobBoardPullCounts(this.jobId, this.jbiTransactionId, (data) => {
  //         this.candidateCounts = data;
  //         this.loadingCountsInfoFlag = false;
  //         if(successCallback) {
  //             successCallback();
  //         }
  //     }, (error) => {
  //         this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
  //     });
  // }

  // getJobBoardPullMatchInfo() {
  //     this.loadingJobMatchesInfoFlag = true;
  //     this.jobService.getJobBoardPullMatchInfo(this.jbiTransactionId, (data) => {
  //         angular.forEach(data, (val, key) => {
  //             if(_.isNull(val.firstName)) {
  //                 val.firstName = "-";
  //             }
  //             if(_.isNull(val.lastName)) {
  //                 val.lastName = "-";
  //             }
  //             if(_.isNull(val.email)) {
  //                 val.email = "-";
  //             }
  //             if(_.isNull(val.phone)) {
  //                 val.phone = "-";
  //             }
  //             val.name = val.firstName + ' ' + val.lastName;

  //             // floor the match score to the lower integer value.
  //             val.score = Math.floor(parseFloat(val.score));
  //             if(val.score >= val.jobThresholdScore) {
  //                 val.intelligenceScorePassFlag = true;
  //             }
  //             val.selectedFlag = false;
  //             this.candidatesList.push(val);
  //         });
  //         this.loadingJobMatchesInfoFlag = false;
  //     }, (error) => {
  //         this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
  //     })
  // }

  toggleSelectAllCandidates() {
    if (this.selectedAllCandidatesFlag) {
      // if selectAllCandidates was already selected, remove all selections
      angular.forEach(this.candidatesList, (val, key) => {
        // if candidate was not already added successfully and was selected, de select it and remove it from associate list
        if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
          val.selectedFlag = false;
          // if selected is removed, remove from candidates to associate list
          _.remove(this.candidatesToAssociateList, {
            candidateId: val.candidateId
          });
        }
      });
      this.selectedAllCandidatesFlag = false;
    } else {
      // if selectAllCandidates was not already selected
      angular.forEach(this.candidatesList, (val, key) => {
        // if candidate was not already added successfully and also not already selected, select it and add to associate list
        if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
          val.selectedFlag = true;
          this.candidatesToAssociateList.push(val);
        }
      });
      this.selectedAllCandidatesFlag = true;
    }
  }

  candidateToAssociateToggle(candidate) {
    // if it is selected, add to associate list
    if (candidate.selectedFlag) {
      this.candidatesToAssociateList.push(candidate);
    } else {
      // if selected is removed, remove from candidates to associate list
      _.remove(this.candidatesToAssociateList, {
        candidateId: candidate.candidateId
      });
      _.remove(this.createJobMatchesObject.overrideNoteDetails, {
        candidateId: candidate.candidateId
      });
    }
  }

  associateCandidates() {
    angular.forEach(this.candidatesToAssociateList, (val, key) => {
      this.createJobMatchesObject.candidateIds.push(val.candidateId);
    });
    this.associatingCandidatesFlag = true;
    const associatingDialog = bootbox.dialog({
      message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
      closeButton: false
    });
    this.jobMatchService.createJobMatches(this.createJobMatchesObject, (data) => {
      this.associatingCandidatesFlag = false;
      associatingDialog.modal('hide');
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      angular.forEach(this.candidatesToAssociateList, (val, key) => {
        // find each associated candidate in the original candidates list
        const index = _.findIndex(this.candidatesList, {
          candidateId: val.candidateId
        });
        // for each candidate, set the added successfully flag to true and selected flag to false
        this.candidatesList[index].candidateMatchedToJob = true;
        this.candidatesList[index].statusOfJobMatch = 'Candidate \'manually\' added to the job.';
        this.candidatesList[index].selectedFlag = false;
        this.candidatesList[index].jobMatchManuallyCreated = true;

        // update notification payload
        const update = this.jobBoarPulledCandidates.update;
        if (update) {
          if (update.unMatchedCandidateIdAndNames && update.unMatchedCandidateIdAndNames.length > 0) {
            update.unMatchedCandidateIdAndNames.forEach(candidate => {
              if (candidate.candidateId === val.candidateId) {
                update.unMatchedCandidateCount--;
                update.matchedCandidateCount++;
                update.matchedCandidateIdAndNames.push(candidate);
                _.remove(update.unMatchedCandidateIdAndNames, {
                  candidateId: val.candidateId
                });
              }
            });
          }
        }

        const create = this.jobBoarPulledCandidates.create;
        if (create) {
          if (create.unMatchedCandidateIdAndNames && create.unMatchedCandidateIdAndNames.length > 0) {
            create.unMatchedCandidateIdAndNames.forEach(candidate => {
              if (candidate.candidateId === val.candidateId) {
                create.unMatchedCandidateCount--;
                create.manuallyMatchedCandidateCount++;
                create.manuallyMatchedCandidateIdAndNames.push(candidate);
                _.remove(create.unMatchedCandidateIdAndNames, {
                  candidateId: val.candidateId
                });
              }
            });
          }
        }
      });

      this.jobBoarPulledCandidates.candidates = JSON.parse(angular.toJson(this.candidatesList));

      // make the candidates to associate list as empty.
      this.candidatesToAssociateList = [];
      // reload the counts to refresh manually added candidates counts
      this._getCandidateCounts();
      this.alertsAndNotificationsService.showBannerMessage('Candidates have been successfully added to the job', 'success');
      this.jobMatchService.requestJobWorkflowRefresh();
      // save api
      if (this.notificationId) {
        this.notificationsService.saveCandidateResumeNotification(this.notificationId, this.jobBoarPulledCandidates, () => {
          // Do Nothing
        }, error => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }
      if (this.closeCallback) {
        this.closeCallback.emit();
      }
    }, (error) => {
      this.associatingCandidatesFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  showOverrideCandidateSuspensionModal(candidate) {
    const candidateId = candidate.candidateId;
    const candidateName = candidate.name;
    const isRelease = candidate.overrideFor === 'RELEASE';
    const suspendedMonths = isRelease ?
      candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
    const releaseDate = isRelease ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
    const allowOverride = candidate.allowOverride;
    const releasedJobDetails = isRelease ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
    const type = isRelease ? 'release' : 'jobLeft';

    if (allowOverride) {
      const config = new ModalConfig();
      config.class = 'custom-modal-65';
      config.initialState = {
        candidateId,
        candidateName,
        suspendedMonths,
        releaseDate,
        allowOverride,
        releasedJobDetails,
        type,
        recruiterDetails: new OverrideNoteDetail(candidateId)
      };
      const bsModalRef: BsModalRef = this.bsModalService.show(OverrideCandidateSuspensionComponent, config);

      bsModalRef.content.saveCallback.subscribe(() => {
        const index = _.findIndex(this.candidatesList, {
          candidateId: candidate.candidateId
        });
        this.createJobMatchesObject.overrideNoteDetails.push(bsModalRef.content.recruiterDetails);
        this.candidatesList[index].allowManualMatch = true;
        this.candidatesList[index].showOverride = false;
        this.candidatesList[index].candidateMatchedToJob = false;
        this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
        this.candidatesList[index].selectedFlag = true;
        this.candidateToAssociateToggle(this.candidatesList[index]);
        bsModalRef.hide();
      });
      bsModalRef.content.cancelCallback.subscribe(() => {
        bsModalRef.hide();
      });

    } else {
      const formattedReleaseDate = this.fourDotFiveDateFormatPipe.transform(releaseDate);
      let displayHtmlText = '';
      if (type === 'release') {
        displayHtmlText = 'Candidate \'<span class=\'emerald\'>' + candidateName + '</span>\' cannot apply for any position as ' +
          'it is within \'<span class=\'emerald\'>' + suspendedMonths + '</span>\' month(s) of candidate\'s previous release. ';
        displayHtmlText = displayHtmlText + 'Candidate was previously released on \'<span class=\'emerald\'>' + formattedReleaseDate +
          '</span>\' from the role \'<span class=\'emerald\'>' + releasedJobDetails.role + '</span>\' ';
        displayHtmlText = displayHtmlText +
          'with Requisition Number \'<span class=\'emerald\'>' + releasedJobDetails.requisitionNumber + '</span>\'.';
      } else {
        displayHtmlText = 'Candidate <span class=\'emerald\'>\'' + candidateName + '\'</span> cannot apply for any position as ' +
          'it is within \'<span class=\'emerald\'>' + suspendedMonths + '</span>\' month(s) of leaving previous job. ';
        displayHtmlText = displayHtmlText + 'Candidate left previous job on \'<span class=\'emerald\'>' + formattedReleaseDate +
          '</span>\' from the role \'<span class=\'emerald\'>' + releasedJobDetails.role + '</span>\' ';
        displayHtmlText = displayHtmlText +
          'with Requisition Number \'<span class=\'emerald\'>' + releasedJobDetails.requisitionNumber + '</span>\'.';
      }

      bootbox.alert({
        closeButton: false,
        title: '<div class=\'alert alert-warning\' style=\'margin-bottom: 0px;\'>' +
          '<i class=\'fas fa-exclamation-triangle fa-fw fa-lg\'></i><strong>Cannot add candidate</strong></div>',
        message: displayHtmlText,
        className: 'zIndex1060',
        buttons: {
          ok: {
            label: 'Ok',
            className: 'btn-info'
          }
        },
        callback: () => {
          this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }
      });
    }
  }

  jobCompare(candidate) {
    const actionObject = new JobMatchAction('Candidate Job Comparison', 'CANDIDATE_JOB_COMPARE', true, null);
    candidate.jobMatchJobId = this.jobId;
    candidate.id = candidate.candidateId;
    this.jobMatchActionsService.performAction('reviewCandidatePull', actionObject, candidate, () => {
    }, () => {
    });
  }

  displayProcessedCandidates(activity) {
    setTimeout(() => {
      let bsModalRef: BsModalRef;
      const config = new ModalConfig();
      config.class = 'custom-modal-xl';
      config.initialState = {
        resolve: {
          jobBoarPulledCandidatesObject: this.jobBoarPulledCandidates,
          activity,
          modalType: 'jobBoardPull',
          activityMap: this.activityMap
        },
        modalInstance: {
          close: () => {
            bsModalRef.hide();
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          },
          dismiss: () => {
            bsModalRef.hide();
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          }
        }
      };
      bsModalRef = this.bsModalService.show(UploadResumesTransactionCandidatesModalComponent, config);
    }, 300);
  }

  getAllActivityTypes() {
    this.activityMap = [];
    this.jobService.getActivityTypes((data) => {
      angular.forEach(data, (val, key) => {
        this.activityMap[val.value] = val.name;
      });
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }
}
